import { Component, ElementRef, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { CommonService } from '@app/core/services/common.service';
import { TrailerSize, TrailerType } from '@app/modules/shipper/components/shipments/load/add-edit-load/add-edit-load.component';
import { procedure, rfpDuration } from '@app/modules/shipper/enums/rfp-enums';
import { MasterService } from '@app/modules/shipper/services/master.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})

export class FilterComponent implements OnInit, AfterViewInit {
  @ViewChild("location") location: ElementRef;
  @ViewChild('factorLocation') factorLocation: any;
  @ViewChild("factorLocation2") factorLocation2: ElementRef;
  @ViewChild("factorCountry") factorCountry: ElementRef;
  @ViewChild("factorZipCode") factorZipCode: ElementRef;
  @ViewChild('mvOrigin') mvOrigin: ElementRef;
  @ViewChild('mvDestination') mvDestination: ElementRef;
  @ViewChild('mvOriginD') mvOriginD: ElementRef;
  @ViewChild('mvDestinationD') mvDestinationD: ElementRef;


  // @Output() filterSource:any;
  @Output() filterAPI: boolean = false;
  @Input() name
  @Input() context

  showhide: boolean = false;
  _trailerSizes = new Array<TrailerSize>();
  _trailerTypes = new Array<TrailerType>();
  _ratingScore: number = 0;
  _totalstar = 5;
  priceError: boolean = false;
  dateRangeError: boolean = false;
  applyedFilter: boolean = false
  locationOriginSuggestions: string[] = [];
  locationDestinationSuggestions: string[] = [];
  filteredOriginSuggestions: string[] = [];
  filteredDestinationSuggestions: string[] = [];
  private readonly locationSuggestionStorageKey = 'filter-location-suggestions';
  mapViewUsers: any[] = [];
  mapViewFilteredUsers: any[] = [];
  mapViewUserSelected = false;
  mapViewOriginCoords: { lat: number; lng: number } | null = null;
  mapViewDestinationCoords: { lat: number; lng: number } | null = null;
  private mapViewPlacesInputs = new WeakSet<HTMLInputElement>();

  constructor(
    private _masterService: MasterService,
    private _formBuilder: FormBuilder,
    private ngZone: NgZone,
    private _commonService: CommonService,
  ) { }

  //#region maps members
  private geoCoder;
  latitude: number = undefined;
  longitude: number = undefined;
  //#endregion

  //form region start
  _form: FormGroup = this._formBuilder.group({
    pickupDate: new FormControl(""),
    deliveryDate: new FormControl(""),

    minPrice: new FormControl(""),
    maxPrice: new FormControl(""),

    origin: new FormControl(""),
    destination: new FormControl(""),

    loadServiceType: new FormControl(""),
    pickupDropoffType: new FormControl(""),
    trailerTypeId: new FormControl(""),
    trailerSizeId: new FormControl(""),
    totalWeight: new FormControl(""),

    duration: new FormControl(""),
    expiryDate: new FormControl(""),
    volume: new FormControl(""),
    loads: new FormControl(""),

    shipmentType: new FormControl(""),
    procedure: new FormControl(""),

    status: new FormControl(""),
    shipmentStatus: new FormControl(""),

    city: new FormControl(""),
    state: new FormControl(""),
    memberSince: new FormControl(""),
    rating: new FormControl(""),
    timePeriod: new FormControl(""),
    startDate: new FormControl(""),
    customStartDate: new FormControl(""),
    customEndDate: new FormControl(""),
    endDate: new FormControl(""),
    filterBy: new FormControl(""),
    scheduledPickup: new FormControl(""),
    scheduledDelivery: new FormControl(""),
    onTimePickup: new FormControl([]),
    onTimeDelivery: new FormControl([]),
    shipperName: new FormControl(""),
    driverName: new FormControl(""),
    truckNumber: new FormControl(""),
    minAmount: new FormControl(""),
    maxAmount: new FormControl(""),
    costType: new FormControl(""),

    userType: new FormControl(""),
    userName: new FormControl(""),
    userId: new FormControl(""),
    radius: new FormControl(""),
    radiusUnit: new FormControl(""),
    minMiles: new FormControl(""),
    maxMiles: new FormControl(""),
    minWeight: new FormControl(""),
    maxWeight: new FormControl(""),
    minRevenuePerMile: new FormControl(""),
    maxRevenuePerMile: new FormControl(""),
    lynkId: new FormControl(""),
    statusType: new FormControl(""),
    pickupDateFrom: new FormControl(""),
    pickupDateTo: new FormControl(""),
    deliveryDateFrom: new FormControl(""),
    deliveryDateTo: new FormControl(""),

    companyType: new FormControl(''),
    plan: new FormControl(''),
  });

  //region ended

  //helper region start
  ngOnInit(): void {
    this.getTrailerDetails();
    this.initializeLocationSuggestions();
    this._form.get('startDate')?.valueChanges.subscribe(() => this.validateDateRange());
    this._form.get('endDate')?.valueChanges.subscribe(() => this.validateDateRange());
    //  setInterval(() =>{
    //    if(this.context && this.context.showAppliedFilterOption && this.context.showAppliedFilterOption.length == 0 ){  
    //      this.context._filter = false
    //    }
    // },500);
  }

  ngAfterViewInit(): void {
    if (this.name !== 'map-view') {
      return;
    }
    this.initMapViewPlacesAutocomplete();
    this.initMapViewUserSearch();
  }

  initMapViewPlacesAutocomplete(): void {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Maps Places API is not loaded");
      return;
    }
    const originElements = [this.mvOrigin?.nativeElement, this.mvOriginD?.nativeElement].filter(Boolean);
    const destinationElements = [this.mvDestination?.nativeElement, this.mvDestinationD?.nativeElement].filter(Boolean);
    originElements.forEach((element) => this.attachMapViewPlaces(element, 'origin'));
    destinationElements.forEach((element) => this.attachMapViewPlaces(element, 'destination'));
  }

  private attachMapViewPlaces(element: HTMLInputElement, field: string): void {
    if (this.mapViewPlacesInputs.has(element)) {
      return;
    }
    this.mapViewPlacesInputs.add(element);

    const autocomplete = new google.maps.places.Autocomplete(element);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
        if (!place || !place.geometry || !place.geometry.location) {
          return;
        }

        const address = this.getMapViewPlaceLabel(place);
        if (address) {
          this._form.get(field)?.setValue(address, { emitEvent: true });
        }

        const coordinates = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
        if (field === 'origin') {
          this.mapViewOriginCoords = coordinates;
        } else {
          this.mapViewDestinationCoords = coordinates;
        }
      });
    });
  }

  private getMapViewPlaceLabel(place: google.maps.places.PlaceResult): string {
    const components = place.address_components || [];
    const locality = components.find((component) => component.types.indexOf('locality') !== -1)?.long_name ||
      components.find((component) => component.types.indexOf('postal_town') !== -1)?.long_name;
    const region = components.find((component) => component.types.indexOf('administrative_area_level_1') !== -1)?.long_name;

    if (locality && region) {
      return `${locality}, ${region}`;
    }
    return place.formatted_address || place.name || '';
  }

  private initMapViewUserSearch(): void {
    const userTypeControl = this._form.get('userType');
    const toggleUserName = (userType: any) => {
      const userName = this._form.get('userName');
      if (userType === undefined || userType === null || userType === '') {
        userName?.disable({ emitEvent: false });
      } else {
        userName?.enable({ emitEvent: false });
      }
    };
    toggleUserName(userTypeControl?.value);
    userTypeControl?.valueChanges.subscribe(toggleUserName);

    this._form.get('userName')?.valueChanges.subscribe((value) => {
      const query = (value || '').toString().trim().toLowerCase();
      if (!query) {
        this.mapViewFilteredUsers = this.mapViewUsers.slice(0, 20);
        return;
      }
      this.mapViewFilteredUsers = this.mapViewUsers
        .filter((user) => (user.name || '').toString().toLowerCase().includes(query))
        .slice(0, 20);
    });
  }
  validatePrice() {
    const minPrice = this.parseNumericValue(this._form.get('minPrice')?.value);
    const maxPrice = this.parseNumericValue(this._form.get('maxPrice')?.value);

    if (minPrice !== null && maxPrice !== null && maxPrice < minPrice) {
      this.priceError = true;
    } else {
      this.priceError = false;
    }
  }
  onChangeRating(argEvent: any) {
    this._ratingScore = argEvent;
    this._form.get('rating').setValue(this._ratingScore)
  }

  filltertoggle() {
    this.showhide = !this.showhide;

    if (this.showhide && this.context?.filterdata) {
      this._form.patchValue(this.context.filterdata);
    }

    if (this.showhide) {
      this.refreshLocationSuggestionsFromContext();
      this.updateLocationFilteredLists();
    }

    document.querySelector('.mat-drawer-content').classList.add('openFillter');
  }

  async applyFilter() {

    if (this._form.invalid) {
      this._commonService.showErrorSnakeBar('Please fill valid input before applying the filter');
      return;
    }

    if (this.context) {
      if (this.name === 'map-view') {
        const userType = this._form.get('userType')?.value;
        const userName = (this._form.get('userName')?.value || '').toString().trim();
        if (userType && !userName) {
          this._commonService.showErrorSnakeBar('Please Fill User Name');
          return;
        }
      }
      this.filterAPI = true;
      this.validatePrice();
      if (this.priceError) {
        this._commonService.showErrorSnakeBar('Max price should not be less than Min price');
        return;
      }
      if (!this.validateDateRange()) {
        this._commonService.showErrorSnakeBar('To Date cannot be before From Date');
        return;
      }
      let _filterData = {};

      for (let key in this._form.value) {
        if (this._form.value.hasOwnProperty(key) && this.hasMeaningfulFilterValue(this._form.value[key])) {
          _filterData = {
            ..._filterData,
            [key]: this._form.value[key]
          };
        }
      }
      _filterData = this.normalizeNumericFilterFields(_filterData);

      if (this.name === 'map-view') {
        if (!(await this.applyMapViewFilterTransforms(_filterData))) {
          return;
        }
      }

      this.applyedFilter = Object.keys(_filterData).length > 0;
      if (Object.keys(_filterData).length) {
        this.context.filterdata = { ..._filterData };
        this.context.filterTable(_filterData, this.filterAPI);
        this.showhide = false;
        this._commonService.showSuccessSnakeBar('Filter Applied')
      } else {
        this._commonService.showErrorSnakeBar('Please choose any field to apply filter');
      }
    }
  }

  private async applyMapViewFilterTransforms(_filterData: any): Promise<boolean> {
    if (_filterData['lynkId'] !== undefined) {
      const lynkId = String(_filterData['lynkId']).trim().toUpperCase();
      if (!/^S\d+$/.test(lynkId)) {
        this._commonService.showErrorSnakeBar('Enter a valid LYNK ID, for example S661105885');
        return false;
      }
      _filterData['lynkId'] = lynkId;
    }

    const radiusRaw = _filterData['radius'];
    if (radiusRaw) {
      const radius = this.parseNumericValue(radiusRaw);
      if (radius === null || radius <= 0) {
        this._commonService.showErrorSnakeBar('Search radius must be a positive number');
        return false;
      }
      const unit = String(_filterData['radiusUnit'] || '').toLowerCase();
      if (unit.startsWith('km')) {
        _filterData['radius'] = parseFloat((radius / 1.609344).toFixed(2));
      }

      const originText = (_filterData['origin'] || '').toString().trim();
      let center = originText ? await this.resolveMapViewOriginCoordinates(originText) : null;
      if (!center && this.mapViewOriginCoords) {
        center = this.mapViewOriginCoords;
      }
      if (!center) {
        this._commonService.showErrorSnakeBar('Please select a valid Origin for radius search');
        return false;
      }
      this.mapViewOriginCoords = center;
      _filterData['originLat'] = center.lat;
      _filterData['originLng'] = center.lng;
    }
    delete _filterData['radiusUnit'];

    ['origin', 'destination'].forEach((field) => {
      if (_filterData[field]) {
        _filterData[field] = this.toCityState(_filterData[field]);
      }
    });

    if (_filterData['statusType']) {
      _filterData['status'] = _filterData['statusType'];
    }
    delete _filterData['statusType'];

    if (this.isMinGtMax(_filterData['minMiles'], _filterData['maxMiles'])) {
      this._commonService.showErrorSnakeBar('Max miles should not be less than Min miles');
      return false;
    }
    if (this.isMinGtMax(_filterData['minWeight'], _filterData['maxWeight'])) {
      this._commonService.showErrorSnakeBar('Max weight should not be less than Min weight');
      return false;
    }
    if (this.isMinGtMax(_filterData['minRevenuePerMile'], _filterData['maxRevenuePerMile'])) {
      this._commonService.showErrorSnakeBar('Max revenue per mile should not be less than Min revenue per mile');
      return false;
    }
    if (this.isFromAfterTo(_filterData['pickupDateFrom'], _filterData['pickupDateTo'])) {
      this._commonService.showErrorSnakeBar('Pickup To date cannot be before From date');
      return false;
    }
    if (this.isFromAfterTo(_filterData['deliveryDateFrom'], _filterData['deliveryDateTo'])) {
      this._commonService.showErrorSnakeBar('Delivery To date cannot be before From date');
      return false;
    }

    return true;
  }

  // The API matches origin/destination against "city, state", so drop anything after it (e.g. the country)
  private toCityState(location: any): string {
    return String(location)
      .split(',')
      .map((part) => part.trim())
      .filter((part) => !!part)
      .slice(0, 2)
      .join(', ');
  }

  private async resolveMapViewOriginCoordinates(origin: string): Promise<{ lat: number; lng: number } | null> {
    if (!origin) {
      return null;
    }
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      return null;
    }
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve) => {
      geocoder.geocode({ address: origin }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
          const location = results[0].geometry.location;
          resolve({ lat: location.lat(), lng: location.lng() });
          return;
        }
        resolve(null);
      });
    });
  }

  private isMinGtMax(min: any, max: any): boolean {
    const minValue = this.parseNumericValue(min);
    const maxValue = this.parseNumericValue(max);
    return minValue !== null && maxValue !== null && maxValue < minValue;
  }

  private isFromAfterTo(from: any, to: any): boolean {
    if (!from || !to) {
      return false;
    }
    const fromDate = new Date(from);
    const toDate = new Date(to);
    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
      return false;
    }
    return toDate < fromDate;
  }

  reload() {
    this._form.reset();
    this._form.patchValue({
      onTimePickup: [],
      onTimeDelivery: []
    }, { emitEvent: false });
    this.dateRangeError = false;
    this.context.filterOptions = [];
    this.context.showAppliedFilterOption = [];
    this.context.filterAPI = false;
    this.context._filter = false;
    this.context.filterdata = {};
    this.applyedFilter = false;
    setTimeout(() => {
      this.context.ngOnInit();
    }, 100);
  }
  reset() {
    this._form.reset();
    this._form.patchValue({
      onTimePickup: [],
      onTimeDelivery: []
    }, { emitEvent: false });
    this.dateRangeError = false;
    this.context.filterOptions = [];
    this.context.showAppliedFilterOption = [];
    this.context._filter = false
    if (this.applyedFilter) {
      this.applyedFilter = false
      this.reload()
    }
  }

  close() {
    this.showhide = !this.showhide;
    if (this.filterAPI == false) {
      this._form.reset();
    }
    this.dateRangeError = false;
    document.querySelector('.mat-drawer-content').classList.remove('openFillter');
  }

  validateDateRange() {
    const fromDate = this._form.get('startDate')?.value;
    const toDate = this._form.get('endDate')?.value;
    if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);
      if (end < start) {
        this.dateRangeError = true;
        return false;
      }
    }
    this.dateRangeError = false;
    return true;
  }

  //region ended

  onCheckEntry(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  onNumericInput(controlName: string, maxDecimals: number = 2) {
    const control = this._form.get(controlName);
    if (!control) {
      return;
    }
    let value = (control.value || '').toString().replace(/,/g, '').replace(/[^0-9.]/g, '');
    const firstDot = value.indexOf('.');
    if (firstDot !== -1) {
      value = value.substring(0, firstDot + 1) + value.substring(firstDot + 1).replace(/\./g, '');
    }
    const [integerPart, decimalPart = ''] = value.split('.');
    const formattedInteger = integerPart ? Number(integerPart).toLocaleString('en-US') : '';
    const formatted = decimalPart !== ''
      ? `${formattedInteger}.${decimalPart.substring(0, maxDecimals)}`
      : formattedInteger;
    control.setValue(formatted, { emitEvent: false });
  }

  onNumericBlur(controlName: string, maxDecimals: number = 2) {
    const control = this._form.get(controlName);
    if (!control) {
      return;
    }
    const parsedValue = this.parseNumericValue(control.value);
    if (parsedValue === null) {
      return;
    }
    control.setValue(parsedValue.toLocaleString('en-US', {
      minimumFractionDigits: maxDecimals,
      maximumFractionDigits: maxDecimals
    }), { emitEvent: false });
  }

  private parseNumericValue(value: any): number | null {
    if (value === undefined || value === null || value === '') {
      return null;
    }
    const normalizedValue = value.toString().replace(/,/g, '');
    const parsedValue = parseFloat(normalizedValue);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  }

  private normalizeNumericFilterFields(filterData: any) {
    const numericKeys = ['minPrice', 'maxPrice', 'totalWeight', 'minAmount', 'maxAmount',
      'radius', 'minMiles', 'maxMiles', 'minWeight', 'maxWeight', 'minRevenuePerMile', 'maxRevenuePerMile'];
    numericKeys.forEach((key) => {
      if (filterData[key] !== undefined && filterData[key] !== null && filterData[key] !== '') {
        const parsedValue = this.parseNumericValue(filterData[key]);
        if (parsedValue !== null) {
          filterData[key] = parsedValue.toFixed(2);
        }
      }
    });
    return filterData;
  }

  private hasMeaningfulFilterValue(value: any): boolean {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return !!value;
  }
  //private region start
  private getTrailerDetails() {
    this._masterService.getTrailerTypes().subscribe((res) => {
      if (res.data) {
        this._trailerTypes = res.data;
      }
    });

    this._masterService.getTrailerSizes().subscribe((res) => {
      if (res.data) {
        this._trailerSizes = res.data;
      }
    });
  }

  mapAutoPopulateForFactorCompany(element: string) {
    if (!window.google) {
      console.error("Google Maps API is not loaded");
      return;
    }
    this.geoCoder = new google.maps.Geocoder();
    let autocomplete = new google.maps.places.Autocomplete(
      this[element].nativeElement,
      {
        types: [],
        //Places to be shown only
        componentRestrictions: { country: [] },
      }
    );

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        //get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }
        //set latitude, longitude and zoom
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.getAddressFieldsForFactorCompany(this.latitude, this.longitude);
      });
    });
  }

  getAddressFieldsForFactorCompany(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            for (var i = 0; i < results[0].address_components.length; i++) {
              var address = results[0].address_components[i];

              if (address.types[0] == "country") {
                this._form.get("factorCountry").setValue(address.long_name);
                this.factorCountry.nativeElement.focus();
              } else if (address.types[0] == "postal_code") {
                this._form.get("factorZipcode").setValue(address.short_name);
                this.factorZipCode.nativeElement.focus();
              } else if (address.types[0] == "administrative_area_level_1") {
                // State
                this._form.get("factorState").setValue(address.long_name);
              } else if (address.types[0] == "locality") {
                this._form.get("factorCity").setValue(address.long_name); // City
              }
            }
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }
  get rfpDuration() {
    return rfpDuration;
  }
  get procedure() {
    return procedure;
  }

  private initializeLocationSuggestions() {
    this.loadLocationSuggestionsFromStorage();
    this.refreshLocationSuggestionsFromContext();
    this.updateLocationFilteredLists();

    this._form.get('origin')?.valueChanges.subscribe((value: string) => {
      this.filteredOriginSuggestions = this.filterSuggestions(value, this.locationOriginSuggestions);
    });

    this._form.get('destination')?.valueChanges.subscribe((value: string) => {
      this.filteredDestinationSuggestions = this.filterSuggestions(value, this.locationDestinationSuggestions);
    });
  }

  private refreshLocationSuggestionsFromContext() {
    const origins: string[] = [];
    const destinations: string[] = [];
    const collectLocations = (rows: any) => {
      if (!Array.isArray(rows)) {
        return;
      }
      rows.forEach((row) => {
        const origin = (row?.origin || '').toString().trim();
        const destination = (row?.destination || '').toString().trim();
        if (origin) {
          origins.push(origin);
        }
        if (destination) {
          destinations.push(destination);
        }
      });
    };

    collectLocations(this.context?.currentDataList);
    collectLocations(this.context?._recentLoads);
    collectLocations(this.context?.dataSource?.data);
    if (this.name === 'map-view') {
      const mapRows = Array.isArray(this.context?.allLoads) && this.context.allLoads.length
        ? this.context.allLoads
        : this.context?.viewportLoads || this.context?.visibleLoads;
      collectLocations(mapRows);
    }

    if (!origins.length && !destinations.length) {
      return;
    }

    this.locationOriginSuggestions = this.mergeUniqueSuggestions(this.locationOriginSuggestions, origins);
    this.locationDestinationSuggestions = this.mergeUniqueSuggestions(this.locationDestinationSuggestions, destinations);
    this.persistLocationSuggestionsToStorage();
  }

  private mergeUniqueSuggestions(existing: string[], incoming: string[]): string[] {
    const result: string[] = [];
    const seen = new Set<string>();

    [...existing, ...incoming].forEach((value) => {
      const normalized = (value || '').trim();
      const key = normalized.toLowerCase();
      if (!normalized || seen.has(key)) {
        return;
      }
      seen.add(key);
      result.push(normalized);
    });

    return result;
  }

  private filterSuggestions(value: string, source: string[]): string[] {
    const input = (value || '').toString().trim().toLowerCase();
    if (!input) {
      return source.slice(0, 20);
    }
    return source
      .filter((item) => item.toLowerCase().includes(input))
      .slice(0, 20);
  }

  private updateLocationFilteredLists() {
    this.filteredOriginSuggestions = this.filterSuggestions(this._form.get('origin')?.value, this.locationOriginSuggestions);
    this.filteredDestinationSuggestions = this.filterSuggestions(this._form.get('destination')?.value, this.locationDestinationSuggestions);
  }

  private loadLocationSuggestionsFromStorage() {
    try {
      const raw = localStorage.getItem(this.locationSuggestionStorageKey);
      if (!raw) {
        return;
      }
      const parsed = JSON.parse(raw);
      this.locationOriginSuggestions = Array.isArray(parsed?.origin) ? parsed.origin : [];
      this.locationDestinationSuggestions = Array.isArray(parsed?.destination) ? parsed.destination : [];
    } catch {
      this.locationOriginSuggestions = [];
      this.locationDestinationSuggestions = [];
    }
  }

  private persistLocationSuggestionsToStorage() {
    const payload = JSON.stringify({
      origin: this.locationOriginSuggestions.slice(0, 300),
      destination: this.locationDestinationSuggestions.slice(0, 300)
    });
    localStorage.setItem(this.locationSuggestionStorageKey, payload);
  }

  onOriginSuggestionSelected(event: MatAutocompleteSelectedEvent) {
    this._form.get('origin')?.setValue(event.option.value);
  }

  onDestinationSuggestionSelected(event: MatAutocompleteSelectedEvent) {
    this._form.get('destination')?.setValue(event.option.value);
  }

  //#region map-view helpers
  onMapViewUserTypeChange(): void {
    const userType = this._form.get('userType')?.value;
    if (userType === undefined || userType === null || userType === '') {
      this.clearMapViewUsers();
      return;
    }
    this.mapViewUsers = [];
    this.mapViewFilteredUsers = [];
    if (this.context && typeof this.context.getMapUsers === 'function') {
      this.context.getMapUsers(userType).subscribe((res) => {
        if (res && (res.statusCode == 200 || res.statusCode == 201)) {
          this.mapViewUsers = Array.isArray(res.data?.user) ? res.data.user : (Array.isArray(res.data) ? res.data : []);
          this.mapViewFilteredUsers = this.mapViewUsers.slice(0, 20);
        }
      });
    }
  }

  onMapViewUserSelected(event: MatAutocompleteSelectedEvent): void {
    const user = event.option.value;
    if (user && user.id !== undefined) {
      this.mapViewUserSelected = true;
      this._form.get('userName').setValue(user.name);
      this._form.get('userId').setValue(user.id);
    }
  }

  private clearMapViewUsers(): void {
    this.mapViewUsers = [];
    this.mapViewFilteredUsers = [];
    this.mapViewUserSelected = false;
    this._form.get('userName').setValue('');
    this._form.get('userId').setValue('');
  }
  //#endregion

}
